module.exports = __webpack_public_path__ + "img/setting_9.9c8f7cc7.svg";